import React, { useEffect, useRef } from 'react';

// El dashboard ITSM (sidebar + Dashboard/Companies/Users/Assets/Scheduler) es la
// SPA de managed-companies, servida desde /public/dash/. Esa SPA lee el token de
// Supabase del localStorage (mismo origen), trae los datos del proxy
// (workers.easytek.cr/api/managed/data, que valida el token) y se renderiza.
// La montamos full-screen tras el login (ProtectedRoute).
//
// URL deep-linking (path-based): el address bar es el del padre (este shell).
//  - Al cargar le pasamos a la SPA la ruta actual del padre vía ?r= (deep-link).
//  - La SPA emite su ruta por postMessage {type:'itsm-nav', path} y la espejamos en
//    el address bar como path real (soporteeasytek.com/companies/icc/users).
//  - En back/forward (popstate) le reenviamos la nueva ruta a la SPA.
const ItsmDashboard = () => {
  const iframeRef = useRef(null);
  const initialPath = typeof window !== 'undefined'
    ? (window.location.pathname + window.location.search) : '/';

  useEffect(() => {
    // When the SPA navigates it emits {itsm-nav, path}. We pushState a new history
    // entry so the browser Back button steps through in-app views (instead of leaving
    // the app). If the nav was itself caused by a Back/Forward (popstate), we only
    // replaceState so we don't fight the browser history.
    let fromPop = false;
    const onMessage = (e) => {
      const d = e.data;
      if (!d || d.type !== 'itsm-nav' || typeof d.path !== 'string') return;
      if (window.location.pathname === d.path) return;
      if (fromPop) { window.history.replaceState(null, '', d.path); fromPop = false; }
      else window.history.pushState(null, '', d.path);
    };
    const onPopState = () => {
      fromPop = true;
      const win = iframeRef.current && iframeRef.current.contentWindow;
      if (win) win.postMessage({ type: 'itsm-route', path: window.location.pathname }, '*');
    };
    window.addEventListener('message', onMessage);
    window.addEventListener('popstate', onPopState);
    return () => {
      window.removeEventListener('message', onMessage);
      window.removeEventListener('popstate', onPopState);
    };
  }, []);

  // Pass the current parent path to the SPA via ?r= so a hard-loaded deep link restores.
  const src = '/dash/?r=' + encodeURIComponent(initialPath);

  return (
    <iframe
      ref={iframeRef}
      src={src}
      title="easyTEK ITSM"
      style={{ border: 0, width: '100vw', height: '100vh', display: 'block' }}
    />
  );
};

export default ItsmDashboard;
